import {
  Box,
  Button,
  Chip,
  Stack,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import { getAllNotice } from "../../api"
import AddNotice from "../modals/AddNotice"
import AddChannel from "../modals/AddChannel"
import dayjs from "dayjs"
import InfScroll from "../ui/InfScroll"

const priorityMap = {
  LOW: "success",
  MEDIUM: "warning",
  HIGH: "error",
}

const limit = 4

const NoticeBoard = () => {
  const [addNoticeModal, setAddNoticeModal] = useState(false)
  const [addChannelModal, setAddChannelModal] = useState(false)
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)
  const [totalPages, setTotalPages] = useState(null)

  const refresh = () => {
    getAllNotice({
      page: 1,
      limit,
    }).then((res) => {
      setData(res.data.rows)
      setCount(res.data, count)
      setTotalPages(Math.max(res.data.totalPages, 1))
    })
    .catch((err) => {
      setTotalPages(page)
      console.log(err)
    })
  }

  const fetchData = () => {
    getAllNotice({
      page,
      limit,
    }).then((res) => {
      setData([...data, ...res.data.rows])
      setCount(res.data, count)
      setTotalPages(Math.max(res.data.totalPages, 1))
    })
    .catch((err) => {
      setTotalPages(page)
      console.log(err)
    })
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <Box sx={{ maxWidth: 600, margin: "0 auto" }}>
      <Stack direction="row" spacing={2} justifyContent="flex-end" mb={2}>
        <Button onClick={() => setAddChannelModal(true)} variant="contained">
          Add Channel
        </Button>
        <Button onClick={() => setAddNoticeModal(true)} variant="contained">
          Add Notice
        </Button>
      </Stack>
      <Stepper orientation="vertical">
        <InfScroll
          count={count}
          next={() => setPage(page + 1)}
          hasMore={page !== totalPages}
        >
          {data?.map((d, i) => (
            <Notice key={i} data={d} />
          ))}
        </InfScroll>
      </Stepper>
      <AddNotice
        isOpen={addNoticeModal}
        close={() => setAddNoticeModal(false)}
        refresh={refresh}
      />
      <AddChannel
        isOpen={addChannelModal}
        close={() => setAddChannelModal(false)}
      />
    </Box>
  )
}

const Notice = ({ data }) => (
  <Step active={true}>
    <StepLabel
      icon={
        <Stack
          alignItems={"center"}
          sx={{
            bgcolor: "primary.main",
            color: "white",
            px: 1.5,
            py: 0.5,
            borderRadius: 2,
          }}
        >
          <span style={{ fontSize: 18 }}>
            {dayjs(data.creationTimestamp).format("DD")}
          </span>
          <span style={{ fontSize: 12 }}>
            {dayjs(data.creationTimestamp).format("MMM")}
          </span>
        </Stack>
      }
    />
    <StepContent>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{data.title}</Typography>
        <Stack direction="row" spacing={1}>
          <Chip label={data?.channel_?.name} />
          <Chip
            label={data?.channel_?.priority}
            color={priorityMap[data?.channel_?.priority]}
          />
        </Stack>
      </Stack>
      <Typography mb={2}>{data.content}</Typography>
      {data.image && (
        <img
          src={data.image}
          alt="img"
          style={{ width: "100%", borderRadius: "1rem" }}
        />
      )}
    </StepContent>
  </Step>
)

export default NoticeBoard
